import { Draw } from "../types/draws"
import { DRAW_INSURANCE_TYPE } from "./constants"

const getReqularDrawLabel = (draw: Draw) => {
  return draw.rejected ? `Rejected Draw #${draw.drawNumber}` : `Draw #${draw.drawNumber}`
}

const getLabelForRevisionDraw = (draw: Draw) => {
  return draw.rejected ? `Rejected SOW Revision #${draw.drawNumber}` : `SOW Revision #${draw.drawNumber}`
}

const getLabelForInsuranceDraw = (draw: Draw) => {
  return draw.rejected ? `Rejected Insurance Draw #${draw.drawNumber}` : `Insurance Draw #${draw.drawNumber}`
}


export const getDrawNumber = (draw: Draw) => {
  if (!draw) {
    return '';
  }
  if (draw?.drawType === DRAW_INSURANCE_TYPE) {
    return getLabelForInsuranceDraw(draw);
  } else if (draw?.revision) {
    return getLabelForRevisionDraw(draw);
  } else {
    return getReqularDrawLabel(draw);
  }
};